import { render, staticRenderFns } from "./MedicalRecordReupload.vue?vue&type=template&id=d5e9c2f6&"
import script from "./MedicalRecordReupload.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordReupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports